import axios from 'axios'

const instance = axios.create({
  baseURL: 'https://tigabujang.herokuapp.com/'
})

export default instance